import { Command, type BaseCommandProperties } from '@canvas/command';

export type AbortCommentCommandProperties = BaseCommandProperties;

/**
 * This command is for `@canvas/experience` purposes, to signal when we want to Abort an experience
 */
export class AbortCommentExperienceCommand extends Command<AbortCommentCommandProperties> {}
